// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"687":"5cacec17","958":"0e7e4ef7"}[chunkId] + ".css";
};